import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingOverlay = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10,
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default LoadingOverlay;
